export var AuditEventAction;
(function (AuditEventAction) {
    AuditEventAction["ProjectCreateSuccess"] = "project.create.success";
    AuditEventAction["ProjectCreateFailed"] = "project.create.failed";
    AuditEventAction["ProjectWorkerStart"] = "project.worker.start";
    AuditEventAction["FileRetrieveSuccess"] = "file.retrieve.success";
    AuditEventAction["FileRetrieveFailed"] = "file.retrieve.failed";
    AuditEventAction["ProjectWorkerSuccess"] = "project.worker.success";
    AuditEventAction["ProjectWorkerFailed"] = "project.worker.failed";
    AuditEventAction["ProjectWorkerProgress"] = "project.worker.progress";
})(AuditEventAction || (AuditEventAction = {}));
export function isFullProjectAuditEvent(event) {
    return (event.action === AuditEventAction.ProjectCreateSuccess ||
        event.action === AuditEventAction.ProjectWorkerStart ||
        event.action === AuditEventAction.FileRetrieveSuccess ||
        event.action === AuditEventAction.FileRetrieveFailed ||
        event.action === AuditEventAction.ProjectWorkerSuccess ||
        event.action === AuditEventAction.ProjectWorkerFailed);
}
export var MimeType;
(function (MimeType) {
    MimeType["Json"] = "application/json";
    MimeType["Txt"] = "text/plain";
    MimeType["Xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    MimeType["Xls"] = "application/vnd.ms-excel";
    MimeType["Csv"] = "text/csv";
    MimeType["Tsv"] = "text/tab-separated-values";
})(MimeType || (MimeType = {}));
export const XlsxMimeTypes = [
    MimeType.Xlsx,
    MimeType.Xls,
    MimeType.Csv,
];
//# sourceMappingURL=types.js.map